import React from 'react';
import { toast } from 'react-toastify';

/**
 * The open-shift texts, written out for the owner to send from his own phone
 * when texting isn't set up — the same list wherever an open shift is offered
 * or texted from: the job page's Open shift panel, and the Calendar's "Route
 * loose jobs" sheet when a day goes out as one open shift. Shows nothing when
 * there are no messages.
 */
export type ShiftDraft = { name: string; phone: string; body: string };

export default function OpenShiftDrafts({ drafts, className = '' }: { drafts: ShiftDraft[] | null | undefined; className?: string }) {
  if (!drafts || drafts.length === 0) return null;
  return (
    <div className={className}>
      <p className="text-xs font-semibold text-orange-900 mb-1.5">Texting isn't set up — send these from your phone:</p>
      <ul className="space-y-1.5">
        {drafts.map((d, i) => (
          <li key={i} className="text-xs bg-white border border-orange-200 rounded-lg px-3 py-2">
            <span className="font-semibold text-gray-800">{d.name}</span>
            <span className="text-gray-500"> · {d.phone}</span>
            <button
              onClick={() => { (navigator.clipboard?.writeText(d.body) ?? Promise.reject()).then(() => toast.success('Copied')).catch(() => {}); }}
              className="ml-2 text-brand-600 underline">copy</button>
            <p className="text-gray-700 mt-0.5 break-words">{d.body}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
